import { render, staticRenderFns } from "./Evolucion.vue?vue&type=template&id=51a2bc3a&scoped=true&"
import script from "./Evolucion.vue?vue&type=script&lang=js&"
export * from "./Evolucion.vue?vue&type=script&lang=js&"
import style0 from "./Evolucion.vue?vue&type=style&index=0&id=51a2bc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2bc3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VCard,VCardText,VCardTitle,VDataTable,VIcon})
